import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { getToUrl } from 'utils/translation';
import classnames from 'classnames';
import { Wrapper, Select, Button } from 'components/Ui';
import { QUANTITY_LIST } from 'utils/selectOptions';

import styles from './styles.scss';

class Item extends PureComponent {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.item.quantity !== prevState.quantity) {
      return { quantity: nextProps.item.quantity };
    }
    return null;
  }

  state = {
    quantity: this.props.item.quantity || 1,
    // term: 1,
  };

  handleQuantityChange = (e) => {
    const quantity = Number(e.target.value);
    this.props.onQuantityChange(this.props.item, quantity);
  };

  // handleTermChange = e => this.setState({ term: e.target.value });

  handleRemove = () => {
    this.props.handleRemove(this.props.item.id);
  };

  render() {
    const {
      props: {
        item: { title, image = {}, price, relatedFee },
        isCheckout,
      },
      state: {
        quantity,
        // term,
      },
    } = this;

    return (
      <Wrapper color="white" className={styles.wrapper}>
        <div className={styles.container}>
          <div className={styles.row}>
            <img
              className={styles.image}
              src={image.url}
              alt={image.fileName}
            />
            <div className={styles.column}>
              <div className={styles.boldText}>{title}</div>
              <div className={styles.boldText}>Installation Fee</div>
            </div>
          </div>
          <div className={classnames(styles.column, styles.alignEnd)}>
            <div className={styles.row}>
              <div className={styles.selectBlock}>
                <div className={styles.row}>
                  <span>Quantity: </span>
                  {isCheckout ? (
                    <div>{quantity}</div>
                  ) : (
                    <Select
                      items={QUANTITY_LIST}
                      value={quantity}
                      style={{ width: 60 }}
                      minHeight={0}
                      onChange={this.handleQuantityChange}
                      className={styles.select}
                    />
                  )}
                </div>
                <div className={styles.note}>
                  Need more than 2?{' '}
                  {<Link to={getToUrl('/get-started', 'U24')}>Contact us</Link>}
                </div>
              </div>
              {/* <div className={styles.selectBlock}>
                <div className={styles.row}>
                  <span>Term: </span>
                  <Select
                    value={term}
                    items={TERM_LIST}
                    onChange={this.handleTermChange}
                    style={{ width: 70 }}
                    minHeight={0}
                    className={styles.select}
                  />
                </div>
                <div className={styles.note}>
                  <Link to={getToUrl('/learn-more', 'U25')}>Learn More</Link>
                </div>
              </div> */}
              <div className={styles.priceBlock}>
                <div className={isCheckout && styles.priceShow}>${price}</div>
                {!isCheckout && (
                  <Button
                    className={styles.link}
                    link
                    onClick={this.handleRemove}
                    text="Remove"
                  />
                )}
              </div>
            </div>
            <div className={styles.secondaryText}>${relatedFee}</div>
          </div>
        </div>
      </Wrapper>
    );
  }
}

Item.propTypes = {
  item: PropTypes.object.isRequired,
  onQuantityChange: PropTypes.func.isRequired,
  handleRemove: PropTypes.func.isRequired,
  isCheckout: PropTypes.bool,
};

export default Item;
